import { render } from "./LightboxItem.vue?vue&type=template&id=45a6c366&scoped=true"
import script from "./LightboxItem.vue?vue&type=script&lang=ts"
export * from "./LightboxItem.vue?vue&type=script&lang=ts"

import "./LightboxItem.vue?vue&type=style&index=0&id=45a6c366&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45a6c366"

export default script